import React from "react";
import styles from "../PanelUser/PanelLayout.module.css";
import { Link } from "react-router-dom";
import axiosInstance from "../../api/axiosConfig";

export default function ResumenProfesional() {
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    axiosInstance
      .get("/api/datapersonal", { headers: { Authorization: token } })
      .then((r) => setUser(r.data))
      .catch(console.error);
  }, []);

  const disponibles = user?.OnlineShifts?.filter(
    (s) => s.status === "pendiente" || s.status === "disponible",
  ) || [];
  const aceptadas = user?.OnlineShifts?.filter(
    (s) => s.status === "aceptado" || s.status === "confirmado",
  ) || [];

  const stats = [
    { label: "Consultas disponibles", sub: "sin asignar", value: disponibles.length },
    { label: "Consultas aceptadas", sub: "confirmadas", value: aceptadas.length },
    { label: "Total consultas", sub: "historial", value: user?.OnlineShifts?.length || 0 },
  ];

  const quickActions = [
    { label: "Ver disponibles", sub: "Gestión de turnos", to: "/panel/consultas/disponibles" },
    { label: "Ver aceptadas", sub: "Turnos confirmados", to: "/panel/consultas/aceptadas" },
    { label: "Mi perfil", sub: "Datos personales", to: "/panel/perfil" },
  ];

  return (
    <>
      <div className={styles.statsGrid} style={{ gridTemplateColumns: "repeat(3, 1fr)" }}>
        {stats.map((s) => (
          <div key={s.label} className={styles.statCard}>
            <p className={styles.statValue}>{s.value}</p>
            <p className={styles.statTitle}>{s.label}</p>
            <p className={styles.statSub}>{s.sub}</p>
          </div>
        ))}
      </div>

      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <h2 className={styles.cardTitle}>Acciones rápidas</h2>
        </div>
        <div className={styles.quickActions}>
          {quickActions.map((a) => (
            <Link key={a.to} to={a.to} className={styles.quickAction}>
              <span className={styles.quickActionTitle}>{a.label}</span>
              <span className={styles.quickActionSub}>{a.sub}</span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
